export enum ESubmissionMethod {
  MANUAL = 'manual',
  CORPPASS = 'corppass',
  /**
   * Written from a Singpass MyInfo consent the personnel gave on the portal (SME-3352 / SME-3353).
   * Mirrors `ESubmissionMethod.MYINFO` on the API side — BE has been sending this value since
   * SME-3353, so a record can already arrive with it.
   */
  MYINFO = 'myinfo',
}
